/*
 * @Author: hehaishen
 * @Date: 2019-08-02 17:03:59
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-01-13 16:53:42
 * @Description:
 */
const arr = [{
    id: "1-1",
    name: "社区管理",
    show: "AAA,AAB,AAC,AAD,AAE,AAF,AAG,AHH,AHI,AHJ,AHK,AHL",
    minorPem: "AAA",
    link: "/home/projectManagement",
    menuItem: null,
    icon: "nav_cm"
},
{
    id: "1-2",
    name: "单位管理",
    show: "AAH,AAI,AAJ,AAK,AAN,AAM,AAL,AAO,AAP,AAQ,AHM,AHN,AHO,",
    minorPem: "AAH",
    link: "/home/enterprise",
    menuItem: null,
    icon: "nav_company"
},
{
    id: "1-10",
    name: "商圈管理",
    show: "AHP,AHQ,AHR,AHS,AHT,AHU,AId,AIe,AIf,AIg",
    minorPem: "AAH",
    link: "/home/tradeArea",
    menuItem: [{
        id: "1-10-1",
        name: "店铺管理",
        show: "AHP,AHQ,AHR,AHS,AHT,AHU,AId,AIe,AIf,AIg",
        minorPem: "AHP",
        link: "/home/shopList"
    }],
    icon: "nav_business"
},
{
    id: "1-3",
    name: "智能电梯",
    show: "AHP,AHQ,AHR,AHS,AHT,AHU,AHV,AHW,AHV,AHX,AHY,AIF,AI0,AI1,AJh,AJi,AJj,AJk,AJl,AJm,AJn,AJo,AJp,AJq,AJr,AJs",
    link: "/home/communityCollect",
    // icon: 'nav_device',
    icon: "nav_elv",
    menuItem: [
        {
            id: "1-3-2",
            name: "电梯合同",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF",
            minorPem: "AHP",
            link: "/home/liftContract"
        },
        {
            id: "1-3-1",
            name: "楼盘采集",
            show: "AHV,AHW,AHV,AHX",
            minorPem: "AHV",
            link: "/home/communityCollect"
        },
        {
            id: "1-3-5",
            name: "厂检管理",
            show: "AHV,AHW,AHV,AHX,AJi",
            // show: "AJh,AJi,AJj,AJk,AJl,AJm,AJn,AJo,AJp,AJq,AJr,AJs,AHV",
            minorPem: "AJi",
            link: "/home/factoryManagement"
        },
        // {
        //     id: '1-3-2',
        //     name: '绑定异常',
        //     show: 'AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6',
        //     link: '/home/bindError'
        // },
        {
            id: "1-3-3",
            name: "打印记录",
            show: "AHY",
            minorPem: "AHY",
            link: "/home/printLog"
        },
        {
            id: "1-3-4",
            name: "舒适度记录",
            show: "AI0,AI1",
            minorPem: "AI0",
            link: "/home/comfortLog"
        }
    ]
},
{
    id: "2-1", //新做的
    name: "智能设备",
    show: "AHP,AHQ,AHR,AHS,AHT,AHU,AHV,AHW,AHV,AHX,AHY,AIF,AI0,AI1,AJh,AJi,AJj,AJk,AJl,AJm,AJn,AJo,AJp,AJq,AJr,AJs,Ama",
    link: "/home/intelligentDevice",
    icon: 'nav_intelDevice',
    // icon: "nav_opera",
    menuItem: [
        {
            id: "2-1-1",
            name: "电梯管理",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF", //新加菜单，没有这个权限限制，复制的电梯合同
            minorPem: "AHP",
            link: "/home/productManage"
        },
        {
            id: "2-1-2",
            name: "设备管理",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF", //新加菜单，没有这个权限限制，复制的电梯合同
            minorPem: "AHP",
            link: "/home/deviceManage"
        },
        {
            id: "2-1-3",
            name: "设备升级",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF", //新加菜单，没有这个权限限制，复制的电梯合同
            minorPem: "AHP",
            link: "/home/deviceUpgrade"
        },
        {
            id: "2-1-4",
            name: "OTA管理",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF", //新加菜单，没有这个权限限制，复制的电梯合同
            minorPem: "AHP",
            link: "/home/newOTAManage"
        },
        {
            id: "2-1-5",
            name: "SIM卡管理",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF", //新加菜单，没有这个权限限制，复制的电梯合同
            minorPem: "AHP",
            link: "/home/newSIMManage"
        },
        {
            id: "2-1-6",
            name: "模型管理",
            show: "AHP,AHQ,AHR,AHS,AHT,AHU,AIF", //新加菜单，没有这个权限限制，复制的电梯合同
            minorPem: "AHP",
            link: "/home/modelManage"
        },
        {
            id: "2-1-7",
            name: "终端质检",
            show: "Ama",
            minorPem: "Ama",
            link: "/home/qualityTest"
        },
        {
            id: "2-1-8",
            name: "设备文件",
            show: "AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6,AIY,AIZ",
            link: "/home/deviceManagementTextList"
        },
        {
            id: "2-1-9",
            name: "协议模板",
            show: "AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6,AIY,AIZ,AI-,AI_,AJA,AJB",
            link: "/home/protocolsTemplateList"
        }
    ]
},
{
    id: "1-4",
    name: "运营管理",
    show: "AAR,AAS,AAT,AAU,AAV,AAW,AAX,AAY,AAZ,AAa,AAb,AAc,AAd,AI2,AI3,AI4,AI5,AI6",
    link: "/home/brandManagement",
    icon: "nav_opera",
    menuItem: [{
        id: "1-4-1",
        name: "品牌管理",
        show: "AAR,AAS,AAT,AAU,AAV",
        minorPem: "AAR",
        link: "/home/brandManagement"
    },
    {
        id: "1-4-2",
        name: "品牌资料",
        show: "AAR,AAS,AAT,AAU,AAV",
        minorPem: "AAR",
        link: "/home/brandInfomation"
    },

    {
        id: "1-4-3",
        name: "故障代码",
        show: "AI2,AI3,AI4,AI5,AI6",
        minorPem: "AI2",
        link: "/home/faultCode"
    },
    {
        id: "1-4-4",
        name: "故障现象",
        show: "AI2,AI3,AI4,AI5,AI6",
        minorPem: "AI2",
        link: "/home/faultSymptom"
    },
    {
        id: "1-4-5",
        name: "厂商设备",
        show: "",
        auth: true,
        link: "/home/manufacturersDevice"
    },

    {
        id: "1-4-6",
        name: "资源管理",
        show: "AHq,AHr,AHs,AHt",
        minorPem: "AHq",
        link: "/home/advertisingManagement"
    },
    {
        id: "1-4-7",
        name: "调试工具",
        show: "",
        auth: true,
        link: "/home/debugToolAccount"
    },
    {
        id: "1-4-8",
        name: "故障对照表",
        show: "",
        auth: true,
        link: "/home/faultContrast"
    },
    ]
},
{
    id: "1-5",
    name: "系统管理",
    show: "AA7,AA8,AA9,AA-,AA_,ABA,ABB,ABC,ABD,ABE,ABF,ABG,ABH,ABI,ABK,ABL,ABM,ABN,ABO,ABP,ABQ,ABR,ABS,ABT,ABU,ABV,ABJ,AIc,AJC,AJu,AJv",
    icon: "nav_sys",
    link: "/home/app-management",
    menuItem: [{
        id: "1-5-1",
        name: "应用管理",
        show: "AA7,AA8,AA9,AA-,AA_,ABA",
        minorPem: "AA7",
        link: "/home/app-management"
    },
    {
        id: "1-5-3",
        name: "账号管理",
        show: "ABB,ABC,ABD,ABE,ABF,ABG,ABH,ABI,AJu,AJv",
        minorPem: "ABB,ABF",
        link: "/home/accountManagement"
    },
    {
        id: "1-5-4",
        name: "功能配置",
        show: "ABK,ABL,ABM,ABN,ABO,ABP,ABQ,ABR,ABS,ABT,ABU,ABV,AIc",
        link: "/home/funcSet"
    },
    {
        id: "1-5-5",
        name: "组织架构",
        show: "AJC",
        minorPem: "AJC",
        link: "/home/sys-framework"
    },
    {
        id: "1-5-2",
        name: "建议反馈",
        show: "ABJ",
        minorPem: "ABJ",
        link: "/home/sys-feedback"
    }
    ]
},
// {
//     id: "1-6",
//     name: "设备管理",
//     show: "AAe,AAf,AAg,AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6,AHa,AH1,AH2,AHb,AHc,AH3,AHd,AH4,AH5,AHf,AH6,AHg,AH7,AHh,AH8,AHi,AHj,AH9,AHk,AH-,AH_,AHl,AHm,AIA,AHn,AHo,AHp,AIT,AIU,AIV,AIW,AIX,AIY,AIZ,AIa,AIb,AIi,AIj,AIk,AIl,AIm,AIn,AIo,AIp,AIq,AIr,AIs,AIt,AIu,AIv,AIw,AIx,AIy,AIz,AI7,AI8,AI9,AI-,AI_,AJA,AJB,AJE,AJF,AJG,AJH,AJI,AJJ,AJK,AJL,AJM,AJN,AJO,AJP,AJQ",
//     link: "/home/deviceManagementInList",
//     icon: 'nav_device',
//     // icon: "nav_opera",
//     menuItem: [{
//             id: "1-6-1",
//             name: "设备管理",
//             show: "AAe,AAf,AAg,AIT",
//             minorPem: "AAe",
//             link: "/home/deviceManagementInList"
//         },
//         {
//             id: "1-6-2",
//             name: "设备调试",
//             show: "AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6,AIU,AIV,AIW,AIX,AIm,AIn,AIo,AIp,AIq,AIr,AIs,AIt,AIu,AIv,AIw,AIx,AIy,AIz,AI7,AI8,AI9,AJE,AJF,AJG,AJH,AJI,AJJ,AJK,AJL,AJM,AJN,AJO,AJP,AJQ",
//             link: "/home/deviceManagementDebugList"
//         },
// {
//     id: "1-6-3",
//     name: "OTA管理",
//     show: "AHa,AH1,AH2,AHb,AHc,AH3,AHd,AH4,AH5,AHf,AH6,AHg,AH7,AHh,AH8,AHi,AHj,AH9,AHk,AH-,AH_,AHl,AHm,AIA,AHn,AIa,AIb,AIi,AIj,AIk,AIl",
//     link: "/home/OTAManage"
// },
// {
//     id: "1-6-4",
//     name: "SIM卡管理",
//     show: "AHo,AHp",
//     link: "/home/SimManage"
// },
// {
//     id: "1-6-5",
//     name: "设备文件",
//     show: "AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6,AIY,AIZ",
//     link: "/home/deviceManagementTextList"
// },
// {
//     id: "1-6-6",
//     name: "协议模板",
//     show: "AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6,AIY,AIZ,AI-,AI_,AJA,AJB",
//     link: "/home/protocolsTemplateList"
// }
// ]
// },
// {
//     id: '1-7',
//     name: '工作管理',
//     show: 'AAe,AAf,AAg,AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6',
//     link: '',
//     // icon: 'nav_device',
//     icon: 'nav_opera',
//     menuItem: [
// {
//     id: '1-6-1',
//     name: "楼盘采集",
//     show: 'AAe,AAf,AAg',
//     minorPem: 'AAe',
//     link: '/home/housesGether'
// },
//         {
//             id: '1-7-2',
//             name: '绑定异常',
//             show: 'AAh,AAi,AAj,AAk,AAl,AAm,AAn,AAo,AAp,AAq,AAr,AAs,AAt,AAu,AAv,AAw,AAx,AAy,AAz,AA0,AA1,AA2,AA3,AA4,AA5,AA6',
//             link: '/home/bindError'
//         },

//     ]
// },
// {
//     id: "1-9",
//     name: "智能终端管理",
//     show: "AHq,",
//     link: "/home/deviceManagementList",
//     // icon: 'nav_device',
//     icon: "nav_terminal",
//     menuItem: [{
//             id: "1-9-1",
//             name: "位置节点管理",
//             show: "AHq,AHr,AHs,AHt",
//             minorPem: "AHq",
//             link: "/home/deviceManagementList"
//         },
//         // {
//         //     id: "1-9-2",
//         //     name: "协议管理",
//         //     show: "AHu,AHv,AHw,AHx",
//         //     link: "/home/protocolManagement"
//         // },
//         {
//             id: "1-9-2",
//             name: "OTA管理",
//             show: "AHy,AHz",
//             link: "/home/otaManagement"
//         },
//         {
//             id: "1-9-3",
//             name: "设备类型管理",
//             show: "AHy,AHz",
//             link: "/home/typeManagement"
//         }
//     ]
// },
{
    id: "1-7",
    name: "消息管理",
    show: "AHq,",
    link: "/home/asideMessaging",
    // icon: 'nav_device',
    icon: "nav_msg",
    menuItem: [{
        id: "1-7-1",
        name: "消息应用",
        show: "AHq,AHr,AHs,AHt",
        minorPem: "AHq",
        link: "/home/asideMessaging"
    },
    {
        id: "1-7-2",
        name: "消息模板",
        show: "AHu,AHv,AHw,AHx",
        link: "/home/messageTemplate"
    },
    {
        id: "1-7-3",
        name: "消息群发",
        show: "AHy,AHz",
        link: "/home/messageGrounp"
    }
    ]
},
{
    id: "1-8",
    name: "技术支持",
    show: "AHq,",
    link: "/home/technicalSupport",
    icon: "nav_technicalSupport",
    default: true,
    menuItem: [
        {
            id: "1-8-1",
            name: "客服管理",
            default: true,
            show: "AHq,AHr,AHs,AHt",
            minorPem: "AHq",
            link: "/home/specialistInfo"
        },
        {
            id: "1-8-2",
            default: true,
            name: "客服账号",
            show: "AHq,AHr,AHs,AHt",
            minorPem: "AHq",
            link: "/home/serviceAccount"
        },
        {
            id: "1-8-3",
            default: true,
            name: "会话工单",
            show: "AHq,AHr,AHs,AHt",
            minorPem: "AHq",
            link: "/home/serviceOrder"
        }
    ]
},
{
    id: "1-11",
    name: "物联应用",
    show: "",
    auth: true,
    link: "/home/iot",
    menuItem: null,
    icon: "nav_iot"
}
];
export default arr;


// WEBPACK FOOTER //
// ./src/mock/menuList.js